<div class="mx-auto max-w-130 rounded-2xl border border-border bg-card p-8 shadow-xl">
  <div class="mb-6 flex flex-col items-stretch justify-between gap-4 border-b border-border pb-5 min-[481px]:flex-row min-[481px]:items-start">
    <div class="flex min-w-0 items-center gap-3">
      <div class="grid size-10 shrink-0 place-items-center rounded-full bg-row-hover text-primary" aria-hidden="true">
        <ng-icon name="lucideUser" size="20" />
      </div>
      <div class="flex min-w-0 flex-col gap-0.5">
        <span class="text-[0.9375rem] leading-tight font-bold text-fg">{{ displayName() }}</span>
        @if (auth.user()?.email) {
          <span class="text-[0.8125rem] leading-snug text-muted max-[480px]:whitespace-normal min-[481px]:truncate">{{ auth.user()?.email }}</span>
        }
        @if (roleLabel(); as role) {
          <span class="text-[0.8125rem] leading-snug font-semibold text-fg-secondary max-[480px]:whitespace-normal min-[481px]:truncate">{{ role }}</span>
        }
      </div>
    </div>
    <button type="button" uiButton variant="outline" size="sm" class="self-end text-primary" (click)="handleLogout()">
      <ng-icon name="lucideLogOut" size="18" />
      <span i18n="@@nav.signOutSidebar">Sign out</span>
    </button>
  </div>

  <h1 class="m-0 mb-3 text-2xl font-bold text-fg">Set a new password</h1>
  <p class="m-0 mb-6 text-[0.9375rem] leading-relaxed text-fg-secondary">
    @if (mode() === 'recovery') {
      Your code was verified. Choose a new password to continue to the backoffice.
    } @else {
      Your account was created with a temporary password. Choose a new password to continue to the backoffice.
    }
  </p>
  <app-change-password-form [mode]="mode()" (passwordChanged)="onPasswordChanged()" />
</div>
